"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SExpField = void 0;
const register_1 = require("../../register");
// eslint-disable-next-line camelcase
const clvm_1 = require("clvm");
exports.SExpField = (0, register_1.buildField)({
    serialize: (value, buf) => {
        const f = new clvm_1.Stream();
        (0, clvm_1.sexp_to_stream)(value, f);
        return Buffer.concat([buf, Buffer.from(f.getValue().raw())]);
    },
    deserialize: (buf) => {
        const f = new clvm_1.Stream(new clvm_1.Bytes(buf));
        const obj = (0, clvm_1.sexp_from_stream)(f, clvm_1.SExp.to);
        // hax
        const f2 = new clvm_1.Stream();
        (0, clvm_1.sexp_to_stream)(obj, f2);
        const serializedLength = f2.getValue().hex().length / 2;
        return [
            obj,
            buf.slice(serializedLength),
        ];
    }
});
//# sourceMappingURL=sexp.js.map